module.exports = __webpack_public_path__ + "img/img3.fe707ecf.jpg";